/* =====================================================
   Dog Socky – productpagina: pijlen op de hoofdfoto.
   Klikt de volgende/vorige thumbnail aan en gebruikt zo
   Dawn's eigen setActiveMedia-logica.
   ===================================================== */
(function () {
  var PREV = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var NEXT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function items(thumbs) {
    return Array.prototype.slice.call(thumbs.querySelectorAll('.thumbnail-list__item'));
  }

  function go(thumbs, dir) {
    var list = items(thumbs);
    if (list.length < 2) return;
    var currentBtn = thumbs.querySelector('button[aria-current="true"]');
    var currentItem = currentBtn ? currentBtn.closest('.thumbnail-list__item') : list[0];
    var idx = list.indexOf(currentItem);
    if (idx < 0) idx = 0;
    var nextIdx = (idx + dir + list.length) % list.length;
    var btn = list[nextIdx].querySelector('button');
    if (!btn) return;
    btn.click();
    list[nextIdx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function makeArrow(cls, label, svg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ds-gallery-arrow ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg;
    return b;
  }

  function init(gallery) {
    if (gallery.dataset.dsArrows) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;
    if (items(thumbs).length < 2) return;
    gallery.dataset.dsArrows = '1';

    var prev = makeArrow('ds-gallery-arrow--prev', 'Vorige afbeelding', PREV);
    var next = makeArrow('ds-gallery-arrow--next', 'Volgende afbeelding', NEXT);
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(thumbs, -1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(thumbs, 1); });
    viewer.appendChild(prev);
    viewer.appendChild(next);
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);
})();
